var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { report } from "./util/mdap";
var dbName = 'idb_tspsdk_v1';
var storeName = 'init_api_cache';
var version = 1;
var idbFactory = window === null || window === void 0 ? void 0 : window.indexedDB;
var _db;
export var support = !!idbFactory && idbFactory.open && typeof idbFactory.open === 'function';
if (!support) {
    report('9b276e0b7e268aed93b79dab879364e9', 0);
}
var open = function () {
    return new Promise(function (resolve, reject) {
        if (!support) {
            reject();
            return;
        }
        if (_db) {
            resolve();
            return;
        }
        var request = idbFactory.open(dbName, version);
        request.onblocked = function (event) {
            console.error('tsp indexedDB open onblocked');
        };
        request.onerror = function (event) {
            console.error('tsp indexedDB open onerror', event);
            reject();
        };
        request.onsuccess = function () {
            console.log('tsp indexedDB open onsuccess');
            _db = request.result;
            _db.onversionchange = function (event) {
                console.log('tsp indexedDB open onversionchange');
                _db.close();
            };
            resolve();
        };
        request.onupgradeneeded = function (event) {
            console.log('tsp indexedDB open onupgradeneeded');
            var db = event.target.result;
            if (!db.objectStoreNames.contains(storeName)) {
                db.createObjectStore(storeName);
            }
        };
    });
};
var exec = function (fnName, args) {
    return new Promise(function (resolve) { return __awaiter(void 0, void 0, void 0, function () {
        var mode, store, request_1, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, open()];
                case 1:
                    _a.sent();
                    mode = fnName === 'put' ? 'readwrite' : 'readonly';
                    store = _db.transaction([storeName], mode).objectStore(storeName);
                    request_1 = store[fnName].apply(store, args);
                    request_1.onsuccess = function () { return resolve(request_1.result); };
                    request_1.onerror = function (e) {
                        // console.log('opt error', e);
                        resolve(null);
                    };
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    console.error('tsp indexedDB exec', fnName, e_1);
                    resolve(null);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); });
};
var IDB = /** @class */ (function () {
    function IDB(name) {
        var customName = name ? "_" + name : '';
        storeName = storeName + customName;
    }
    IDB.prototype.get = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, exec('get', [query])];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        });
    };
    IDB.prototype.set = function (key, value) {
        return exec('put', [value, key]);
    };
    return IDB;
}());
export default IDB;
//# sourceMappingURL=indexDB.js.map